export const REEL_BASE_SWIPE_SPEED_MS = 500;
export const REEL_SWIPE_SPEED_MULTIPLIER = 1.3;
export const REEL_FAST_SWIPE_SPEED_MS = Math.round(REEL_BASE_SWIPE_SPEED_MS / REEL_SWIPE_SPEED_MULTIPLIER);

export const REEL_PENDING_REVEAL_START = 0.4;
export const REEL_PENDING_REVEAL_END = 0.6;
export const REEL_PENDING_REVEAL_POINTER_THRESHOLD = 0.85;
